module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-article.json
// module id = 108
// module chunks = 60335399758886 191130700161134